import Vue from "vue";
import VueRouter from "vue-router";
// import Dashboard from "@/views/dashboard/index.vue";

import store from "../store";

import initMiddleware from "./middleware/configure";
import userMiddleware from "./middleware/handleuser";
import debugMiddleware from "./middleware/debug";

// import bugsnagClient from "./../plugins/bugsnag";

import signoutpage from "@/views/signout";

Vue.use(VueRouter);

console.log("Router loaded");

/**
 *
 * @param {Array<String>} permissions Array of roles, or false
 */

function componentLoader(store, fn) {
  return () => {
    // (Vuex) Loading begins now
    store.commit("setLoading", true);

    // (Vuex) Call when loading is done
    const done = () => {
      store.commit("setLoading", false);
    };
    const onError = error => {
      console.log("GOT ERROR", error);
      store.commit("setLoading", false);
      router.push({ name: "error-500" });
    };
    const promise = fn();
    promise.then(done, onError);
    return promise;
  };
}
let load = fn => componentLoader(store, fn);
const routes = [
  {
    path: "/signout",
    name: "signout",
    component: signoutpage
  },
  {
    path: "/notfound",
    name: "notfound",
    props: true,
    component: load(() =>
      import(/* webpackChunkName: "notfound" */ "@/views/notfound")
    )
  },
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: { name: "home" },
    component: load(() =>
      import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue")
    ),
    beforeEnter: (to, from, next) => {
      if (!store.state.aws_user) {
        next({ name: "signin" });
        return;
      } else {
        next();
      }
    },
    children: [
      {
        path: "home",
        name: "home",
        component: load(() =>
          import(/* webpackChunkName: "dashboard" */ "@/views/home")
        )
      },
      {
        path: "forbidden",
        name: "forbidden",
        component: load(() =>
          import(/* webpackChunkName: "dashboard" */ "@/views/nopermissions")
        )
      },
      {
        path: "billing",
        name: "billing",
        redirect: { name: "billing-account" },
        meta: { permissions: ["super admin", "admin"] },
        component: load(() =>
          import(/* webpackChunkName: "billing" */ "@/views/billing")
        ),
        children: [
          {
            path: "account",
            name: "billing-account",
            meta: { permissions: ["super admin", "admin"] },
            component: load(() =>
              import(
                /* webpackChunkName: "billing" */ "@/views/billing/views/account.vue"
              )
            )
          },
          {
            path: "plans",
            name: "billing-plans",
            meta: { permissions: ["super admin", "admin"] },

            component: load(() =>
              import(
                /* webpackChunkName: "billing" */ "@/views/billing/views/plans.vue"
              )
            )
          }
        ]
      },
      {
        path: "adminlist",
        name: "adminlist",
        meta: { permissions: ["super admin", "admin"] },
        component: load(() =>
          import(/* webpackChunkName: "adminlist" */ "@/views/adminlist")
        )
      },
      {
        path: "coursebuilder",
        name: "coursebuilder",
        meta: { permissions: ["writer", "publisher"] },
        component: load(() =>
          import(
            /* webpackChunkName: "coursebuilder" */ "@/views/coursebuilder"
          )
        )
      },
      {
        path: "delivery/homepage",
        name: "coursedelivery",
        meta: { permissions: ["distribution"] },
        component: load(() =>
          import(
            /* webpackChunkName: "coursedelivery" */ "@/views/coursedelivery"
          )
        )
      },
      {
        path: "delivery/embeds",
        name: "delivery-embeds",
        meta: { permissions: ["distribution"] },

        component: load(() =>
          import(/* webpackChunkName: "embeds" */ "@/views/embeds")
        )
      },
      {
        path: "delivery/bulkenrollments",
        name: "delivery-bulk",
        meta: { permissions: ["distribution"] },
        component: load(() =>
          import(
            /* webpackChunkName: "bulkenrollment" */ "@/views/bulk-enrollment"
          )
        )
      },

      {
        path: "analytics",
        name: "analytics",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(/* webpackChunkName: "analytics" */ "@/views/analytics")
        )
      },
      {
        path: "analytics/:courseid",
        name: "course-analytics",
        props: true,
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(/* webpackChunkName: "analytics" */ "@/views/course-analytics")
        )
      },
      {
        path: "users",
        name: "users",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(/* webpackChunkName: "users" */ "@/views/userlist")
        )
      },
      {
        path: "users/:courseid",
        name: "usersbycourse",
        props: true,
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(
            /* webpackChunkName: "users" */ "@/views/userlist/views/bycourse"
          )
        )
      },
      {
        path: "responses",
        name: "responses",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(/* webpackChunkName: "responses" */ "@/views/responses")
        )
      },
      {
        path: "responses/:courseid/days",
        props: true,
        name: "responsesbycourse",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(
            /* webpackChunkName: "responses" */ "@/views/responses/views/bycourse"
          )
        )
      },
      {
        path: "responses/:courseid/days/:dayid",
        props: true,
        name: "responsesbyday",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(
            /* webpackChunkName: "responses" */ "@/views/responses/views/byday"
          )
        )
      },
      {
        path: "integrations",
        props: true,
        name: "integrations",
        meta: { permissions: ["analyst"] },
        component: load(() =>
          import(/* webpackChunkName: "zapier" */ "@/views/zapier")
        )
      },
      {
        path: "editor/draft/:id",
        name: "coursebuilder-editor",
        props: route => ({ id: route.params.id, type: "writer" }),
        meta: { permissions: ["writer"] },
        component: load(() =>
          import(/* webpackChunkName: "courseedit" */ "@/views/contenteditor")
        )
      },
      {
        path: "editor/published/:id",
        name: "coursebuilder-editor-published",
        meta: { permissions: ["publisher"] },
        props: route => ({ id: route.params.id, type: "publisher" }),
        component: load(() =>
          import(/* webpackChunkName: "courseedit" */ "@/views/contenteditor")
        )
      },
      {
        path: "editor/notfound",
        name: "course-notfound",
        component: load(() =>
          import(/* webpackChunkName: "notfound" */ "@/views/notfound")
        )
      },
      {
        path: "settings",
        name: "settings",
        meta: { permissions: ["admin", "super admin"] },
        component: load(() =>
          import(/* webpackChunkName: "settings" */ "@/views/settings")
        )
      },
      {
        path: "*",
        name: "dashboard-lost",
        component: load(() =>
          import(/* webpackChunkName: "dashboard" */ "@/views/notfound")
        )
      },
      {
        path: "500_error",
        name: "error-500",
        component: load(() =>
          import(/* webpackChunkName: "dashboard" */ "@/views/500-error")
        )
      }
    ]
  },
  {
    path: "/signin",
    name: "signin",
    redirect: "auth"
  },
  {
    path: "/auth",
    name: "auth",
    beforeEnter: (to, from, next) => {
      if (
        store.state.aws_user &&
        store.state.organization &&
        store.state.organization._id
      ) {
        next({ name: "dashboard" });
        return;
      } else {
        if (!store.state.organization || !store.state.organization._id) {
          next({ name: "notfound" });
          return;
        }
        next();
      }
    },
    component: load(() => import(/* webpackChunkName: "auth" */ "@/views/auth"))
  },
  {
    path: "/invite/:code",
    name: "invite",
    props: true,
    component: load(() =>
      import(/* webpackChunkName: "invite" */ "@/views/invite")
    )
  },
  {
    path: "/",
    name: "empty",
    redirect: { name: "home" }
  },
  {
    path: "*",
    name: "unknown",
    redirect: { name: "home" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes
});
router.beforeEach(initMiddleware);
router.beforeEach(userMiddleware);
router.beforeEach(debugMiddleware);
//Async Load Components
// import apm from "@/plugins/elastic-apm";

router.beforeEach((to, from, next) => {
  try {
    const { permissions } = { permissions: [], ...(to.meta || {}) };
    /**
     * @type {Array<String>}
     */
    const userPermissions = store.getters["getUser"]
      ? Array.isArray(store.getters["getUser"].permissions)
        ? store.getters["getUser"].permissions
        : []
      : [];
    const good = userPermissions.filter(perm => {
      return permissions.includes(perm);
    });
    console.log(
      "[Permissions]",
      "Found permissions",
      good,
      permissions,
      userPermissions
    );

    if (good.length < 1 && permissions.length > 0) {
      throw new Error("Missing permissions");
    } else {
      next();
    }
  } catch (err) {
    console.log("Route Blocked", err);
    router.push({ name: "forbidden" });
  }
});

router.beforeEach((to, from, next) => {
  next();
  try {
    // const permissions =
    //   store.getters.getUser && Array.isArray(store.getters.getUser.permissions)
    //     ? store.getters.getUser.permissions
    //     : [];
    const email =
      store.getters.getAWSUser &&
      store.getters.getAWSUser.attributes &&
      store.getters.getAWSUser.attributes.email
        ? store.getters.getAWSUser.attributes.email
        : "unknownemail";

    window.Intercom("boot", {
      hide_default_launcher: true,
      app_id: "g70w2pns",
      email: `${email}`,
      user_id: `${
        store.getters["getUser"]
          ? store.getters["getUser"]._id
          : `${Date.now() + "unknown" + Math.random()}`
      }`,
      created_at: store.getters["getUser"]
        ? store.getters["getUser"].createdAt
        : Date.now(),
      custom_launcher_selector: "#supportchat",
      subdomain: `${
        store.getters["getOrganization"]
          ? store.getters["getOrganization"].subdomain
          : ""
      }`,
      organization_name: `${
        store.getters["getOrganization"]
          ? store.getters["getOrganization"].name
          : ""
      }`
    });
  } catch (err) {
    console.error("Intercom Error", err);
  }
});
router.beforeEach((to, from, next) => {
  try {
    window.analytics.identify(
      store.getters["getUser"] && store.getters["getUser"]
        ? store.getters["getUser"]._id
        : null
    );
    window.analytics.page(`${to.name}`);
    console.log("Segment ID");
  } catch (err) {
    console.error("Segment Error", err);
  }
  console.info(`%cFetching route ${to.path}`, "color:blue;font-size:14px;", to);
  // store.commit("setLoading", true);
  next();
});
//Remove Async Load Icon
router.afterEach((to, from, next) => {
  console.info(`%cAcquired route ${to.path}`, "color:blue;font-size:14px;");
  // store.commit("setLoading", false);
});
export default router;
